import {API_DRIVER} from "../configs/axios";

export const SomService = {
    callBarringList: (integrationId, userId, iccIdList, numbersBlockedList) => {
        const callBarringListDto = {
            integrationId: integrationId,
            userId: userId,
            iccIdList: iccIdList,
            numbersBlockedList: numbersBlockedList
        }
        return API_DRIVER.post("/api/som/callBarringList", callBarringListDto)
    },
    getEnablingClasses: (integrationId, simList) => {
        const enablingClassDto = {
            integrationId: integrationId,
            simList: simList
        }
        return API_DRIVER.post("/api/sim/enablingClass", enablingClassDto)
    },
    modifyEnablingClass: (integrationId, userId, simList, enablingClass) => {
        const modifyEnablingClassDto = {
            integrationId: integrationId,
            userId: userId,
            enableClass: enablingClass,
            simList: simList
        }
        return API_DRIVER.post("/api/som/enablingClass", modifyEnablingClassDto)
    },
    getEnablingData: (integrationId, simList) => {
        const enablingDataDto = {
            integrationId: integrationId,
            simList: simList
        }
        return API_DRIVER.post("/api/sim/enablingData", enablingDataDto)
    },
    modifyEnablingData: (integrationId, userId, simList, enablingData) => {
        const modifyEnablingDataDto = {
            integrationId: integrationId,
            userId: userId,
            simList: simList,
            enablingData: enablingData
        }
        return API_DRIVER.post("/api/som/enablingData", modifyEnablingDataDto)
    },
    modifyAllowList: (integrationId, userId, toRemoveIccIdList, toAddIccIdList, sim) => {
        const modifyAllowListDto = {
            integrationId: integrationId,
            userId: userId,
            toRemoveIccIdList: toRemoveIccIdList,
            toAddIccIdList: toAddIccIdList,
            sim: sim
        }
        return API_DRIVER.post("/api/som/allow-list", modifyAllowListDto);
    },
    resetSimPassword: (integrationId, userId, simList, smsMobilePhone) => {
        const resetPasswordDto = {
            integrationId: integrationId,
            simList: simList,
            userId: userId,
            smsMobilePhone: smsMobilePhone
        }
        return API_DRIVER.post("/api/som/reset-sim-password", resetPasswordDto)
    },
    changeIpAddress: (changeIpDto) => {
        return API_DRIVER.post(`/api/som/change-ip`, changeIpDto)
    },
    changeApn: (changeApnDto) => {
        return API_DRIVER.post(`/api/som/change-apn`, changeApnDto)
    },
    fetchModifyApnOptions: (integrationId, iccId) => {
        return API_DRIVER.get(`/api/sim/${iccId}/change-apn/integrationId/${integrationId}`)
    },
    changeRamGroup: (changeRamGroupDto) => {
        return API_DRIVER.post("/api/som/change-ram-group", changeRamGroupDto)
    },
    canMakeSomCall: (checkSomCallDto) => {
        return API_DRIVER.post(`/api/som/can-make-call`, checkSomCallDto)
    }
}
